export interface Skill {
  id: string;
  label: string;
  category: 'tecnica' | 'comportamental' | 'idioma';
}

export const SKILLS_CATALOG: Skill[] = [
  // Técnicas
  { id: "excel_basico", label: "Excel Básico", category: "tecnica" },
  { id: "excel_intermediario", label: "Excel Intermediário", category: "tecnica" },
  { id: "pacote_office", label: "Pacote Office", category: "tecnica" },
  { id: "google_workspace", label: "Google Workspace", category: "tecnica" },
  { id: "canva", label: "Canva", category: "tecnica" },
  { id: "redes_sociais", label: "Gestão de Redes Sociais", category: "tecnica" },
  { id: "digitacao", label: "Digitação", category: "tecnica" },
  { id: "atendimento_cliente", label: "Atendimento ao Cliente", category: "tecnica" },
  { id: "vendas", label: "Vendas", category: "tecnica" },
  { id: "logica_programacao", label: "Lógica de Programação", category: "tecnica" },
  { id: "html_css", label: "HTML/CSS Básico", category: "tecnica" },
  { id: "figma", label: "Figma", category: "tecnica" },
  { id: "notion", label: "Notion", category: "tecnica" },
  { id: "trello", label: "Trello/Kanban", category: "tecnica" },
  { id: "fotografia", label: "Fotografia", category: "tecnica" },
  { id: "edicao_video", label: "Edição de Vídeo", category: "tecnica" },
  { id: "redacao", label: "Redação", category: "tecnica" },
  { id: "analise_dados", label: "Análise de Dados", category: "tecnica" },

  // Comportamentais
  { id: "comunicacao", label: "Comunicação", category: "comportamental" },
  { id: "trabalho_equipe", label: "Trabalho em Equipe", category: "comportamental" },
  { id: "proatividade", label: "Proatividade", category: "comportamental" },
  { id: "organizacao", label: "Organização", category: "comportamental" },
  { id: "pontualidade", label: "Pontualidade", category: "comportamental" },
  { id: "resolucao_problemas", label: "Resolução de Problemas", category: "comportamental" },
  { id: "criatividade", label: "Criatividade", category: "comportamental" },
  { id: "lideranca", label: "Liderança", category: "comportamental" },
  { id: "adaptabilidade", label: "Adaptabilidade", category: "comportamental" },
  { id: "empatia", label: "Empatia", category: "comportamental" },
  { id: "gestao_tempo", label: "Gestão do Tempo", category: "comportamental" },
  { id: "pensamento_critico", label: "Pensamento Crítico", category: "comportamental" },

  // Idiomas
  { id: "ingles_basico", label: "Inglês Básico", category: "idioma" },
  { id: "ingles_intermediario", label: "Inglês Intermediário", category: "idioma" },
  { id: "espanhol_basico", label: "Espanhol Básico", category: "idioma" },
  { id: "libras", label: "Libras", category: "idioma" },
];

export function getSkillById(id: string): Skill | undefined {
  return SKILLS_CATALOG.find(s => s.id === id);
}

export function getSkillsByCategory(category: Skill['category']): Skill[] {
  return SKILLS_CATALOG.filter(s => s.category === category);
}

export function calculateMatchScore(
  studentSkills: string[],
  requiredSkills: string[],
  niceSkills: string[]
): { percentage: number; matchedRequired: string[]; matchedNice: string[]; missingRequired: string[]; missingNice: string[] } {
  const matchedRequired = requiredSkills.filter(s => studentSkills.includes(s));
  const matchedNice = niceSkills.filter(s => studentSkills.includes(s));
  const missingRequired = requiredSkills.filter(s => !studentSkills.includes(s));
  const missingNice = niceSkills.filter(s => !studentSkills.includes(s));

  const requiredWeight = 2;
  const niceWeight = 1;
  const totalWeight = requiredSkills.length * requiredWeight + niceSkills.length * niceWeight;

  if (totalWeight === 0) return { percentage: 100, matchedRequired, matchedNice, missingRequired, missingNice };

  const score = (matchedRequired.length * requiredWeight + matchedNice.length * niceWeight) / totalWeight;
  return {
    percentage: Math.round(score * 100),
    matchedRequired,
    matchedNice,
    missingRequired,
    missingNice,
  };
}
